import React from 'react'
import {
  Typography,
  Paper,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Divider,
  Radio,
  withStyles,
} from '@material-ui/core'
import styles from './styles'

const ContentSelector = ({
  classes,
  flattenedHeaders,
  selectedTitle,
  onTitleSelect,
}) => {
  return (
    <>
      <Typography className={classes.titlePaper}>
        Select content from your source
      </Typography>
      <Paper variant="outlined" className={classes.scrollableContainer}>
        <List className={classes.listContainer}>
          {flattenedHeaders.map((attachment, attachmentIndex) => (
            <React.Fragment key={`pdf-${attachmentIndex}`}>
              {attachmentIndex > 0 && <Divider className={classes.divider} />}
              <ListItem className={classes.pdfListItem}>
                <ListItemText
                  primary={attachment.fileName}
                  primaryTypographyProps={{
                    className: classes.pdfFileName,
                  }}
                />
              </ListItem>
              {attachment.headers &&
                attachment.headers.map((item, index) => (
                  <React.Fragment key={`${item.element_id}-${index}`}>
                    <ListItem
                      button
                      selected={selectedTitle?.element_id === item.element_id}
                      onClick={() => onTitleSelect(item)}
                    >
                      <ListItemIcon className={classes.listItemIcon}>
                        <Radio
                          checked={
                            selectedTitle?.element_id === item.element_id
                          }
                          size="small"
                        />
                      </ListItemIcon>
                      <ListItemText
                        primary={item.element_id}
                        primaryTypographyProps={{
                          className: classes.contentListItem,
                          style: {
                            paddingLeft: item.level * 20 + 8,
                          },
                        }}
                      />
                    </ListItem>
                  </React.Fragment>
                ))}
            </React.Fragment>
          ))}
        </List>
      </Paper>
    </>
  )
}

export default withStyles(styles)(ContentSelector)
